export default __webpack_public_path__ + "static/media/mobile.7ed1658e.svg";